function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Row, Container, Col } from 'react-bootstrap';
import { Skeleton, message, Button, Modal, Drawer, Divider, List, Space, Alert } from 'antd';
import { Input } from 'antd';
import Common from "../components/includes/Common";
import { PieChart, PlusCircleFill, DashCircleFill, XCircleFill } from 'react-bootstrap-icons';
import moment from "moment";
import CashierTransactionsList from "../components/CashierTransactionsList";
import ProductsGrid from "../components/ConsumablesGrid";
import Receipt from "../components/Receipt";
import ConsumableReceipt from "./ConsumableReceipt";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Search = Input.Search;
var confirm = Modal.confirm;
var ConsumablesOut = function ConsumablesOut() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    dataChanged = _useState2[0],
    setDataChanged = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isReportModalOpen = _useState4[0],
    setIsReportModalOpen = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    successMessage = _useState8[0],
    setSuccessMessage = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    searchWord = _useState0[0],
    setSearchWord = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    totalCash = _useState10[0],
    setTotalCash = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isFormLoading = _useState12[0],
    setIsFormLoading = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedItems = _useState14[0],
    setSelectedItems = _useState14[1];
  var onSearch = function onSearch(v) {
    if (v.target.value.length > 0) {
      setSearchWord(v.target.value);
      alert(v.target.value);
    }
  };
  var handleNewSelected = function handleNewSelected(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          available_quantity: item.available_quantity,
          quantity: extElementQuant + 1,
          cost_price: item.cost_price
        }]);
      });
    } else {
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          available_quantity: item.available_quantity,
          quantity: 1,
          cost_price: item.cost_price
        }]);
      });
    }
  };
  var handleRemoveItem = function handleRemoveItem(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      if (extElementQuant <= 0) {
        handleClearItem(item);
        return;
      }
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
      setSelectedItems(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          label: item.label,
          available_quantity: item.available_quantity,
          quantity: extElementQuant - 1,
          cost_price: item.cost_price
        }]);
      });
    }
  };
  var handleClearItem = function handleClearItem(item) {
    if (selectedItems.filter(function (i) {
      return i.id == item.id;
    }).length > 0) {
      var extElementQuant = selectedItems.filter(function (i) {
        return i.id == item.id;
      })[0].quantity;
      setSelectedItems(selectedItems.filter(function (i) {
        return i.id != item.id;
      }));
    }
  };
  var handleOrder = function handleOrder(selectedItems, totalCash) {
    confirm({
      title: "Confirmez-vous la sortie du stock ?",
      content: /*#__PURE__*/_jsx(ConsumableReceipt, {
        selectedItems: selectedItems,
        totalCash: totalCash
      }),
      onOk: function onOk() {
        processOrder(selectedItems, totalCash);
      }
    });
  };
  var processOrder = function processOrder(selectedItems, totalCash) {
    setIsFormLoading(true);
    var itemsIdArray = Array();
    var itemsQuantityArray = Array();
    selectedItems.forEach(function (e) {
      itemsIdArray.push(e.id);
      itemsQuantityArray.push(e.quantity);
    });
    axios.post(Common.baseApiUrl + "consumableout", {
      items: itemsIdArray.join(','),
      quantities: itemsQuantityArray.join(','),
      user_id: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        message.success({
          content: response.data.message,
          delay: 4
        });
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        printR();
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  return /*#__PURE__*/_jsxs(Container, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), selectedItems.length > 0 && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/logo_sos.jpeg",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(ConsumableReceipt, {
        selectedItems: selectedItems,
        totalCash: totalCash
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kaloum, Manquepas - Tel: 622 32 59 32"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 5,
        md: 6,
        children: /*#__PURE__*/_jsxs("div", {
          className: "white-bg cool-radius",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "cart-content",
            children: [/*#__PURE__*/_jsx(List, {
              dataSource: selectedItems,
              renderItem: function renderItem(item) {
                return /*#__PURE__*/_jsxs(List.Item, {
                  children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: item.label
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx("br", {}), "QUANTITE : ", item.quantity, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx(Button, {
                        icon: /*#__PURE__*/_jsx(PlusCircleFill, {
                          size: 25
                        }),
                        onClick: function onClick() {
                          handleNewSelected(item);
                        },
                        type: "default"
                      }), /*#__PURE__*/_jsx(Button, {
                        icon: /*#__PURE__*/_jsx(DashCircleFill, {
                          size: 25
                        }),
                        onClick: function onClick() {
                          handleRemoveItem(item);
                        },
                        type: "default"
                      }), /*#__PURE__*/_jsx(Button, {
                        icon: /*#__PURE__*/_jsx(XCircleFill, {
                          size: 25
                        }),
                        onClick: function onClick() {
                          handleClearItem(item);
                        },
                        type: "default"
                      })]
                    })]
                  })]
                });
              }
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: function onClick() {
                handleOrder(selectedItems, totalCash);
              },
              block: true,
              children: /*#__PURE__*/_jsx("b", {
                children: "VALIDER"
              })
            }), /*#__PURE__*/_jsx("br", {})]
          }), /*#__PURE__*/_jsx("div", {
            className: "cart-buttons"
          })]
        })
      }), /*#__PURE__*/_jsxs(Col, {
        lg: 7,
        md: 6,
        children: [/*#__PURE__*/_jsx(ProductsGrid, {
          selectHandler: handleNewSelected
        }), /*#__PURE__*/_jsx("br", {})]
      })]
    }), /*#__PURE__*/_jsx(Drawer, {
      destroyOnClose: true,
      visible: isReportModalOpen,
      headerStyle: {
        background: '#F08A8D',
        borderRadius: '0px'
      },
      width: "90%",
      onClose: function onClose() {
        setIsReportModalOpen(false);
      },
      footer: null,
      title: /*#__PURE__*/_jsx("b", {
        children: "RAPPORT DU JOUR"
      }),
      children: /*#__PURE__*/_jsx(CashierTransactionsList, {
        dataChanged: dataChanged
      })
    })]
  });
};
export default ConsumablesOut;